import { createFileRoute } from '@tanstack/react-router'

import { TenantBackupsPage } from '@/pages/tenants/detail/TenantBackupsPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/backups')({
  component: TenantBackupsPage,
})
